<template>
    <div>
        <div class="row">

            <div class="col-md-12">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <router-link :to="{name:'home'}">{{$t("inicio")}}</router-link>
                        </li>
                        <li class="breadcrumb-item">
                            <router-link :to="{name:'informes'}">{{$t("informes")}}</router-link>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">{{$t('informePersonalizado')}}</li>
                    </ol>
                </nav>
            </div>

            <div class="col-md-12">
                <div class="card">
                    <div class="row">

                        <div class="col-md-3">

                            <div class="form-group">
                                <label for="listBusiness">{{$t("negocio")}}</label>

                                <el-select class="select-default"
                                           size="large"
                                           v-model="idBusiness"
                                           filterable
                                           :placeholder="$t('seleccionaNegocio')"
                                           @change="getTpv()">
                                    <el-option v-for="business in listBusinesses"
                                               class="select-primary"
                                               :value="business.id"
                                               :label="business.establishmentName"
                                               :key="business.id">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="col-md-2">
                            <div class="form-group">

                                <div class="col-md-12">
                                    <label for="listTPV">{{$t("TPV")}}</label>
                                </div>

                                <div style="width: 80%">
                                    <el-select class="select-default"
                                               size="large"
                                               v-model="idTpv"
                                               filterable
                                               @change="getVentas()"
                                               :placeholder="$t('seleccionaNegocio')">
                                        <el-option v-for="tpv in listTpv"
                                                   class="select-primary"
                                                   :value="tpv.id"
                                                   :label="tpv.nameShow"
                                                   :key="tpv.id">
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>


                        </div>


                        <div class="col-md-4">
                            <div class="form-group">
                                <label>{{$t('fecha')}}</label>
                                <el-date-picker
                                        v-model="value4"
                                        type="datetimerange"
                                        format="dd-MM-yyyy HH:mm"
                                        :start-placeholder="$t('fechaInicio')"
                                        :end-placeholder="$t('fechaFin')">
                                </el-date-picker>
                            </div>
                        </div>


                        <div class="col-md-2">
                            <label>&nbsp;</label>
                            <div class="form-group">
                                <button class="btn btn-primary" @click="getVentas"><i
                                        class="fa fa-refresh" v-if="loading"></i>
                                    {{$t("consultar")}}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div class="col-md-12">
                <div class="card">
                    <template v-if="data.length > 0">

                        <div class="table-responsive" style="overflow: auto">
                            <table class="table table-bordered table-striped ">
                                <thead class="thead-dark">
                                <tr>
                                    <th>
                                        {{$t('nombreDelDispositivo')}}
                                    </th>
                                    <th>
                                        {{$t('importe')}}
                                    </th>
                                    <th>
                                        {{$t('acciones')}}
                                    </th>

                                </tr>
                                </thead>

                                <tbody>

                                <tr v-for="obj in data">
                                    <td>
                                        <div>{{$t('dispositivo')}} {{obj.dispo}}</div>
                                    </td>
                                    <td align="right">
                                        <div>{{obj.amount | currency}}</div>
                                    </td>
                                    <td width="5%" align="left">
                                        <div>
                                            <el-checkbox-group v-model="idsCabecera">
                                                <el-checkbox :label="obj.dispo">{{$t('dispositivo')}} {{obj.dispo}}</el-checkbox>
                                            </el-checkbox-group>
                                        </div>
                                    </td>
                                </tr>
                                </tbody>
                                <tfoot>
                                <tr>
                                    <td class="table-success"><strong>{{$t("total")}}:</strong></td>
                                    <td class="text-right table-success"><strong>{{getTotalDispos |currency}}</strong>
                                    </td>
                                    <td class="text-right table-success"></td>
                                </tr>
                                </tfoot>
                            </table>
                        </div>

                        <div class="col-md-12 text-right">
                            <div class="form-group">

                                <button @click="executeMarshall()" class="btn btn-success">
                                    {{$t('guardar')}}
                                </button>

                                <!--<button @click="getMarshalls()" class="btn btn-success">-->
                                    <!--Get Marshall-->
                                <!--</button>-->

                                <!--<button @click="updateMarshalls()" class="btn btn-success">-->
                                    <!--Update Marshall-->
                                <!--</button>-->


                                <router-link
                                        :to="{name:'home', params:{'idBusiness':idBusiness}}">
                                    <button class="btn btn-danger">
                                        {{$t('cerrar')}}
                                    </button>
                                </router-link>
                            </div>
                        </div>


                    </template>
                    <template v-else>

                        <div class="alert alert-danger" role="alert">
                            {{$t("noHayVentasEnEsteRangoDeFechas")}}
                        </div>
                    </template>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
    import Datepicker from 'vuejs-datepicker';
    import {
        DatePicker,
        Select,
        Option,
        Dropdown,
        DropdownItem,
        DropdownMenu,
        Button,
        Checkbox,
        CheckboxGroup
    } from 'element-ui'
    import swal from 'sweetalert2'
    import moment from 'moment'
    import CabeceraInformes from "../../../../components/CabeceraInformes/CabeceraInformes";
    import bus from '../../../../bus'

    export default {
        created() {
            this.$store.dispatch("setNameRoute", "Ventas por negocio");
            this.getBusiness();


            if (this.$store.getters.dateTo && this.$store.getters.dateFrom) {

                this.value4[0] = this.$store.getters.dateFrom;
                this.value4[1] = this.$store.getters.dateTo;

            }
        },


        components: {
            CabeceraInformes,
            [DatePicker.name]: DatePicker,
            [Select.name]: Select,
            [Dropdown.name]: Dropdown,
            [DropdownItem.name]: DropdownItem,
            [DropdownMenu.name]: DropdownMenu,
            [Button.name]: Button,
            [Option.name]: Option,
            [Checkbox.name]: Checkbox,
            [CheckboxGroup.name]: CheckboxGroup
        },
        data() {
            return {
                loading: false,

                value4: [new Date(new Date().getFullYear(), new Date().getMonth(), 1), new Date()],

                dateRangeOptions1Comercial: {
                    firstDayOfWeek: 1,
                },


                //DATOS
                data: [''],
                listTpv: [],
                idTpv: 0,
                idBusiness: 0,
                idsCabecera: [],
                datefrom: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
                dateto: new Date(),
                listBusinesses: [],

            }
        },
        computed: {

            getTotalDispos() {
                let total = 0;
                let index = 0;
                this.data.forEach(function (d) {

                    if (d.amount !== 0) {

                        total += d.amount;

                        index++;

                    }
                });


                return total;
            }

        },
        methods: {


            getBusiness() {
                var config = {
                    params: {
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + "general/getBusinessesByUser", config)
                    .then(function (response) {

                        vm.listBusinesses = response.data.result;


                        if (vm.$store.getters.idBusiness) {
                            vm.idBusiness = vm.$store.getters.idBusiness;
                        }
                        else {

                            vm.idBusiness = response.data.result[0].id;
                        }


                        vm.getTpv();

                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },


            getTpv() {

                if (this.idBusiness.length > 0) {


                    var config = {
                        params: {
                            idBusiness: this.idBusiness,
                            jwt: this.$store.getters.jwt
                        },
                        headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                    };

                    let vm = this;
                    this.axios.get(this.$store.getters.apiUrl + "general/getTpvsByBusiness", config)
                        .then(function (response) {
                            if (response.data.response) {


                                vm.listTpv = response.data.result;
                                vm.idTpv = response.data.result[0].id


                                vm.getVentas();


                            }
                            vm.loading = false;

                        })
                        .catch(function (error) {
                            console.log(error);
                        });
                }

            },

            executeMarshall() {


                var controller = "executeMarshall";

                var config = {
                    params:{
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };
                var params = {
                    idTpv: this.idTpv,
                    idsCabecera: this.idsCabecera,
                    date: moment(this.value4[0]).unix(),
                    idBusiness: this.idBusiness,
                    jwt: this.$store.getters.jwt

                };

                let vm = this;

                this.axios.post(this.$store.getters.apiUrl + 'marshall/' + controller, params, config)
                    .then(function (response) {
                        if (response.data.response) {

                            vm.$notify({
                                message: vm.$t('marshallEjecutadoCorrectamente'),
                                icon: 'nc-icon nc-check-2',
                                timeout: 2000,
                                horizontalAlign: 'right',
                                verticalAlign: 'top',
                                type: 'success'
                            });

                        }
                        else {
                            swal({
                                title: vm.$t('atención'),
                                text: response.data.message,
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });
                        }

                    });


            },
            getVentas() {


                if (this.idBusiness.length > 0) {

                    if (this.value4 === null) {
                        swal({
                            title: this.$t('ups'),
                            text: this.$t('seleccioneUnaFechaDeInicioYUnaFechaDeFin'),
                            confirmButtonClass: 'btn btn-info btn-fill',
                            type: 'error'
                        });

                    } else {

                        let secondsDesde = moment(this.value4[0]).unix();
                        let secondsHasta = moment(this.value4[1]).unix();

                        if (secondsHasta < secondsDesde) {
                            swal({
                                title: this.$t('ups'),
                                text: this.$t('laFechaDeInicioNoPuedeSerPosteriorALaDeFin'),
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });
                        } else {
                            this.$store.dispatch("setDateTo", this.value4[1]);
                            this.$store.dispatch("setDateFrom", this.value4[0]);

                            this.loading = true;


                            var config = {
                                params: {
                                    idBusiness: this.idBusiness,
                                    idTpv: this.idTpv,
                                    datefrom: moment(this.value4[0]).unix(),
                                    dateto: moment(this.value4[1]).endOf("day").unix(),
                                    jwt: this.$store.getters.jwt
                                },
                                headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                            };

                            let vm = this;
                            this.$store.dispatch("setIdBusiness", this.idBusiness);
                            this.axios.get(this.$store.getters.apiUrl + "marshall/getSalesByDispoByBusiness", config)
                                .then(function (response) {
                                    if (response.data.response) {

                                        vm.data = response.data.result;
                                    }
                                    else {

                                        swal({
                                            title: vm.$t('atencion'),
                                            text: response.data.result,
                                            confirmButtonClass: 'btn btn-info btn-fill',
                                            type: 'error'
                                        });

                                    }
                                    vm.loading = false;

                                })
                                .catch(function (error) {
                                    console.log(error);
                                });
                        }
                    }
                }

            },
            getMarshalls() {

                var config = {
                    params: {
                        idTpv: this.idTpv,
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + "marshall/getKeep", config)
                    .then(function (response) {
                        if (response.data.response) {

                        }
                        else {

                            swal({
                                title: vm.$t('atencion'),
                                text: response.data.result,
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });

                        }
                        vm.loading = false;

                    })
                    .catch(function (error) {
                        console.log(error);
                    });

            },

            updateMarshalls() {


                var controller = "updateMarshall";

                var config = {
                    params:{
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };
                var params = {
                    idTpv: this.idTpv,
                    idMarshall:6,
                    jwt: this.$store.getters.jwt

                };

                let vm = this;

                this.axios.post(this.$store.getters.apiUrl + 'marshall/' + controller, params, config)
                    .then(function (response) {
                        if (response.data.response) {

                            vm.$notify({
                                message: vm.$t('marshallEjecutadoCorrectamente'),
                                icon: 'nc-icon nc-check-2',
                                timeout: 2000,
                                horizontalAlign: 'right',
                                verticalAlign: 'top',
                                type: 'success'
                            });

                        }
                        else {
                            swal({
                                title: vm.$t('atencion'),
                                text: response.data.message,
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });
                        }

                    });

            }


        }


    }
</script>

<style scoped>

    a li {
        color: #111;
    }

    .card {
        padding: 20px;
    }

    .div-export {
        margin-bottom: 10px;
    }


</style>




// WEBPACK FOOTER //
// src/pages/Dashboard/Informes/Marshall/VentasDispositivos.vue